// Cards the agent shows (UI control v1 `card.show`). A tap is an input, equal to speech.
export interface CardMsg {
  card_id: string;
  kind: string;
  data: Record<string, unknown>;
}

interface Option {
  label: string;
  value: string;
}

export function Card({ card, picked, onPick }: { card: CardMsg; picked?: string; onPick: (cardId: string, value: string, label: string) => void }) {
  const title = String(card.data.title ?? "");
  const subtitle = card.data.subtitle ? String(card.data.subtitle) : "";

  if (card.kind === "slot_grid") {
    const options = (card.data.options as Option[] | undefined) ?? [];
    return (
      <section class="card slots" aria-label={title}>
        <h2>{title}</h2>
        {subtitle && <p class="card-sub">{subtitle}</p>}
        <div class="slot-grid">
          {options.map((o) => (
            <button
              key={o.value}
              type="button"
              class={`slot ${picked === o.value ? "picked" : ""}`}
              aria-pressed={picked === o.value}
              onClick={() => onPick(card.card_id, o.value, o.label)}
            >
              {o.label}
            </button>
          ))}
        </div>
      </section>
    );
  }

  if (card.kind === "confirm") {
    const lines = (card.data.lines as { label: string; value: string }[] | undefined) ?? [];
    return (
      <section class="card ticket" aria-label={title}>
        <h2>
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M5 12.5l4.5 4.5L19 7.5" />
          </svg>
          {title}
        </h2>
        <dl>
          {lines.map((l) => (
            <div key={l.label}>
              <dt>{l.label}</dt>
              <dd>{String(l.value)}</dd>
            </div>
          ))}
        </dl>
      </section>
    );
  }

  // Unknown kinds render their title, so a new card type never breaks the page.
  return title ? (
    <section class="card">
      <h2>{title}</h2>
    </section>
  ) : null;
}
